/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Sort_CreatedInputs */

const cs_documents_sort_created = /** @type {(inputs: Documents_Sort_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější`)
};

const en_documents_sort_created = /** @type {(inputs: Documents_Sort_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest`)
};

/**
* | output |
* | --- |
* | "Newest" |
*
* @param {Documents_Sort_CreatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_sort_created = /** @type {((inputs?: Documents_Sort_CreatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Sort_CreatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_sort_created(inputs)
	return cs_documents_sort_created(inputs)
});